import { openModal } from '@core/components/ModalStack';
import { AddEditPaymentModalProps } from './AddEditPaymentModal';

export async function openAddEditPayment(props: AddEditPaymentModalProps) {
  const { AddEditPaymentModal } = await import('./AddEditPaymentModal');

  openModal(AddEditPaymentModal, props);
}
